export const validateText = (
  text: string,
  rules: { min: number; max: number },
): boolean => {
  const trimmedText = text.trim();

  return trimmedText.length >= rules.min && trimmedText.length <= rules.max;
};
